<template>
    <span class="tooltip static -mt-4 mb-4 xs:absolute  font-semibold top-5 underline hover:no-underline right-5 p-3 cursor-pointer" :title="text" @click="open=!open">
        <svg version="1.2" preserveAspectRatio="none" style="display: inline; margin-right: 5px; overflow: visible; opacity: 1; mix-blend-mode: normal; width: 20px; height: 20px; transform:  translateY(-2px);" class="ng-element" data-id="1aa04ffdc6d2452594c163529c026339"><g transform="translate(0, 0) rotate(0)"><path style="stroke-width: 0px; stroke-linecap: butt; stroke-linejoin: miter; fill: rgb(13, 13, 13);" d="M9,15h2v-6h-2zM10,0c-5.52,0 -10,4.48 -10,10c0,5.52 4.48,10 10,10c5.52,0 10,-4.48 10,-10c0,-5.52 -4.48,-10 -10,-10zM10,18c-4.41,0 -8,-3.59 -8,-8c0,-4.41 3.59,-8 8,-8c4.41,0 8,3.59 8,8c0,4.41 -3.59,8 -8,8zM9,7h2v-2h-2z"></path></g><defs><path id="path-161721378094416" d="M9,15h2v-6h-2zM10,0c-5.52,0 -10,4.48 -10,10c0,5.52 4.48,10 10,10c5.52,0 10,-4.48 10,-10c0,-5.52 -4.48,-10 -10,-10zM10,18c-4.41,0 -8,-3.59 -8,-8c0,-4.41 3.59,-8 8,-8c4.41,0 8,3.59 8,8c0,4.41 -3.59,8 -8,8zM9,7h2v-2h-2z"></path></defs></svg>
        {{text}}
        <portal to="form-modal" >
            <div v-if="open"  class="h-full mx-72 flex flex-col relative  justify-between py-12 font-semibold bg-white" style="min-width: min(100%, 900px)" >
                <svg version="1.2" @click="open=false" preserveAspectRatio="none" viewBox="0 0 24 24" class="absolute top-3 cursor-pointer right-3" data-id="fbad0f126f1642a6b7ba68880b4f39a8" 
                    style="opacity: 1; mix-blend-mode: normal; fill: rgb(18, 18, 18); width: 32px; height: 32px;"
                >
                        <g><path xmlns:default="http://www.w3.org/2000/svg" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" style="fill: rgb(18, 18, 18);"></path></g>
                </svg>
                <slot/>
                <div class="flex flex-col font-semibold justify-evenly pt-8">
                    <h1 style="padding-bottom: 0px">Have a question?</h1>
                    <span class="py-4">Our team are available 9am-5pm Monday to Friday.</span>
                    <a href="tel:03331039575" @click.prevent class="flex flex-row items-center justify-center">
                        <img class="inline-block" src="imgs/phone.png" style="width: 40px; height: auto;"/>
                        <span class="pb-1 font-semibold " style="font-size: 22px">0333 103 9575</span>
                    </a>
                </div>
            </div>
        </portal>
    </span>
</template>
<script>
export default {
    props: ['text', 'title'],
    data() {
        return {
            open: false,
        }
    }
}
</script>
<style lang="scss" scoped>
    .tooltip {
        // top: 20px;
        // right: 20px;
        // padding-right: 10px;
    }

</style>